import axios from 'axios'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router'
import {
  Assign,
  Assign2,
  ContainerPage2,
  ContainerPageRel,
  CxAssign,
  DataAudit,
  RelForm,
  RelFormFormulario6,
  TabelaPadraoRelatorio,
  TabelaPadraoRelatorio2,
  TitlePageRelTab,
  RelFormFormulario7,
  TitleOfPageRel,
  TitlePageRel,
  TitlePageRel1,
  TitlePageRel2
} from '../../Components/Main'
import Indicador from '../../Components/Dash/indicador'
import '../../styles/pages/MenuDireito/relatorioAuditoria.css'

// import RelatorioAuditoriasPDF from '../Relatorio/reports/Relatorio/RelatorioAuditoriasPDF'

function RelatorioAudit() {
  const exportRef = useRef()
  const exportAsImage = async element => {
    const canvas = await html2canvas(element, {
      dpi: 1080,
      scale: 3,
      useCORS: true,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: Math.max(element.scrollHeight, element.offsetHeight),
      height: Math.max(element.scrollHeight, element.offsetHeight)
    })
    const image = canvas.toDataURL('image/png')
    console.log(image)
    var imgWidth = 210
    var pageHeight = 295
    var imgHeight = Math.max(element.scrollHeight, element.offsetHeight)
    var heightLeft = imgHeight
    var doc = new jsPDF('p', 'mm', 'a4')
    var position = 10 // give some top padding to first page
    var totalPDFPages = Math.ceil(
      Math.max(element.scrollHeight, element.offsetHeight) / 11149
    )
    console.log(imgHeight)
    doc.addImage(image, 'PNG', 0, position, imgWidth, pageHeight)
    heightLeft -= pageHeight
    for (var i = 1; i <= totalPDFPages; i++) {
      console.log(heightLeft)
      position = heightLeft - imgHeight + 10 // top padding for other pages
      doc.addPage()
      doc.addImage(image, 'PNG', 0, position, imgWidth, pageHeight)
      heightLeft -= pageHeight
    }
    doc.save('auditoria.pdf')
    console.log(image)
  }

  let id = useParams()

  const [auditoria, setAuditoria] = useState([])
  const [audData, setaudData] = useState('')
  const [unidade, setUnidade] = useState('')
  const [locDescricao, setlocDescricao] = useState('')
  const [audNota, setaudNota] = useState('')
  const [audResponsavelLocal, setaudResponsavelLocal] = useState('')
  const [audEmailResponsavel, setaudEmailResponsavel] = useState('')
  const [pesNome, setpesNome] = useState('')
  const [audTelefoneResponsavel, setaudTelefoneResponsavel] = useState('')
  const [audAssinatura, setaudAssinatura] = useState('')
  const [audAssinaturaCliente, setaudAssinaturaCliente] = useState('')
  const [audObservacoes, setAudObservacoes] = useState('')
  const [idAuditoria, setIdAuditoria] = useState('')
  const [audcodigoGUID, setAudcodigoGUID] = useState('')
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/auditoria/guid/' +
        id['IdRetornoAuditoria']
      )
      .then(response => {
        setAuditoria(response.data)
        setaudData(response.data[0].audFinalizadoEm)
        setUnidade(response.data[0].uniRazaoSocial)
        setlocDescricao(response.data[0].locDescricao)
        setaudNota(response.data[0].audNota)
        setaudAssinatura(response.data[0].audURLAssinaturaAuditor)
        setaudResponsavelLocal(response.data[0].audResponsavelLocal)
        setpesNome(response.data[0].pesNome)
        setaudEmailResponsavel(response.data[0].audEmailResponsavel)
        setaudTelefoneResponsavel(response.data[0].audTelefoneResponsavel)
        setaudAssinaturaCliente(response.data[0].audURLAssinaturaResponsavel)
        setAudObservacoes(response.data[0].audObservacoes)
        setIdAuditoria(response.data[0].IdRetornoAuditoria)
        setAudcodigoGUID(response.data[0].audCodigoGUID)
      })
  }, [])
  const areas = auditoria.map(q => q.rtiSubArea)


  const [auditoriasLongoPrazo, setAuditoriasLongoPrazo] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/auditoria/local/longoprazo/' +
        id['IdRetornoAuditoria']
      )
      .then(response => {
        setAuditoriasLongoPrazo(response.data)
      })
  })

  //console.log(AuditoriasLongoPrazo)

  return (
    <div className='divCorpo' >
      <ContainerPageRel>
        <a
          // href={'https://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?id=' + idAuditoria}
          href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?guid=${audcodigoGUID}`}
          target="_blank"
          rel="noreferrer"
        >
          {/* <button className="verifObserv2"></button> */}
          <i class="verifObserv2 fa fa-file-pdf" ></i>
        </a>
        <TitleOfPageRel>
          <div
            className="logoRelatorioRel"
            style={{ width: '200px', height: '80px' }}
          />
          <TitlePageRel style={{ height: '80px' }}>
            RELATÓRIO DE AUDITORIA
          </TitlePageRel>
        </TitleOfPageRel>
        <TitlePageRel1>
          <div>CLIENTE: {unidade}</div>
          <DataAudit>Data da Auditoria: {audData.substring(0, 10)}</DataAudit>
        </TitlePageRel1>

        <RelForm>
          <div className='relFormFormulario1'>
            <label className="TtlInfoRel1">
              LOCAL AUDITADO
              <input disabled className="InfoRel1" value={locDescricao} />
            </label>
            <label className="TtlInfoRel2">
              E-MAIL
              <input
                disabled
                className="InfoRel2"
                value={audEmailResponsavel}
              />
            </label>
            <label className="TtlInfoRel3">
              AUDITOR
              <input disabled className="InfoRel3" value={pesNome} />
            </label>
          </div>
          <div className='relFormFormulario2'>
            <label className="TtlInfoRel4">
              RESPONSÁVEL
              <input
                disabled
                className="InfoRel4"
                value={audResponsavelLocal}
              />
            </label>
            <label className="TtlInfoRel5">
              TELEFONE
              <input
                disabled
                className="InfoRel5"
                value={audTelefoneResponsavel}
              />
            </label>
            <label className="TtlInfoRel6">
              HORA
              <input
                disabled
                className="InfoRel6"
                value={audData.substring(11, 16)}
              />
            </label>
          </div>
          <div className='relFormFormulario3'>
            <div className="FuncaoResultadoRel1">NOTA</div>
            <div className={`${parseFloat(audNota.toString()) >= 8
              && parseFloat(audNota.toString()) <= 10
              ? 'FuncaoResultadoRel2'
              :
              parseFloat(audNota.toString()) >= 6
                && parseFloat(audNota.toString()) <= 7.9
                ? 'FuncaoResultadoRel2Yellow'
                :
                parseFloat(audNota.toString()) >= 3
                  && parseFloat(audNota.toString()) <= 5.9
                  ? 'FuncaoResultadoRel2Orange'
                  :
                  parseFloat(audNota.toString()) >= 0
                    && parseFloat(audNota.toString()) <= 2.9
                    ? 'FuncaoResultadoRel2Red'
                    : ' '}`} >

              {audNota.toString().replace('.', ',')}

            </div>
          </div>
          <div className='relFormFormulario4'>
            <div>
              <table className="tabelaNotas">
                <tbody>
                  <tr style={{ position: 'relative', border: 'none', marginBottom: '10px' }}>
                    <td className="TdRelPTS">PONTOS</td>
                    <td className="TdRelPTS" colSpan={2}>
                      CLASSIFICAÇÂO SANITÁRIA
                    </td>
                  </tr>
                  <tr style={{ position: 'relative', border: 'none' }}>
                    <td className="TdRelPTS">10,0 a 8,00</td>
                    <td className="TdRelA" style={{ lineHeight: '35px', width: '90px' }}>A</td>
                    <td className="TdRel1">BOM</td>
                  </tr>
                  <tr style={{ position: 'relative', border: 'none' }}>
                    <td className="TdRelPTS">7,99 a 6,00</td>
                    <td className="TdRelB" style={{ lineHeight: '35px' }}>B</td>
                    <td className="TdRel1">REGULAR</td>
                  </tr>
                  <tr style={{ position: 'relative', border: 'none' }}>
                    <td className="TdRelPTS">5,99 a 3,00</td>
                    <td className="TdRelC" style={{ lineHeight: '35px' }}>C</td>
                    <td className="TdRel1">RUIM</td>
                  </tr>
                  <tr style={{ position: 'relative', border: 'none' }}>
                    <td className="TdRelPTS">2,99 a 0,00</td>
                    <td className="TdRelD" style={{ lineHeight: '35px' }}>D</td>
                    <td className="TdRel1">INACEITÀVEL</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </RelForm>



        <RelFormFormulario6>
          Este relatório de Auditoria Sanitária realizado pela Cozinha e Saúde
          Segurança dos Alimentos nas áreas de produção, manipulação e
          armazenamento de alimentos têm o objetivo de identificar as não
          conformidades encontradas, baseadas nas Leis e Normas Sanitárias
          Vigentes. Independente da nota final da Auditoria Sanitária,
          avaliações consideradas GRAVES ou GRAVÍSSIMAS expõe o estabelecimento
          a interdições sanitárias, gerando risco à saúde dos comensais. Segue
          abaixo as considerações:
        </RelFormFormulario6>


        <TitlePageRel2>RESULTADO DE LONGO PRAZO:</TitlePageRel2>

        <RelForm>
          {auditoriasLongoPrazo
            .filter(val => {
              return val
            })
            .map(auditoria => (
              <a
                className="UniClienteMes"
                href={`http://cozinhaesaude.hitperformance.com.br/RelatorioAuditoria/${auditoria.audCodigoGUID}`}
                target={'_blank'}
                rel={'noreferrer'}
              >
                {/* <
        className="UniClienteMes"
        href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?id=${auditoria.IdRetornoAuditoria}`}
        target={'_blank'}
        rel={'noreferrer'}
      > */}
                <div style={{ marginLeft: '5px' }}>
                  <Indicador
                    p_resultado={auditoria.audNota}
                    p_restaurante=""//{auditoria.locDescricao}
                    p_data={auditoria.CriadoEm}
                    p_cor={
                      parseInt(auditoria.audNota) < 3
                        ? 'red'
                        : parseInt(auditoria.audNota) < 6 &&
                          parseInt(auditoria.audNota) >= 3
                          ? 'orange'
                          : parseInt(auditoria.audNota) < 8 &&
                            parseInt(auditoria.audNota) >= 6
                            ? 'yellow'
                            : 'green'
                    }
                  />
                </div>
              </a>
            ))}
        </RelForm>

        <TitlePageRel2>RELATO GERAL DA AUDITORIA:</TitlePageRel2>

        <RelFormFormulario6>
          {audObservacoes}
        </RelFormFormulario6>

        <TabelaPadraoRelatorio>
          <table style={{ border: "0" }}>
            <tbody style={{ border: "0" }}>
              <tr style={{ position: 'relative', border: '0px solid #077e1a' }}>
                <td style={{ width: '25%', border: "0" }}><TitlePageRelTab>Área</TitlePageRelTab></td>
                <td style={{ width: '75%', border: "0" }}><TitlePageRelTab>Relato Área</TitlePageRelTab></td>
                {/* <td><TitlePageRelTab>Nota</TitlePageRelTab></td> */}
              </tr>
              {areas
                .filter((q, idx) => areas.indexOf(q) === idx)
                .map(area => (
                  <tr style={{ position: 'relative', width: '100%', border: '0', borderBottom: '1px solid #077e1a' }}>
                    <td style={{ width: '25%', border: "0" }}><RelFormFormulario7>{area}</RelFormFormulario7></td>
                    <td style={{ width: '75%', border: "0px" }}>
                      {auditoria
                        .filter(val => {
                          if (val.rtiSubArea === area) {
                            return val
                          }
                        })
                        .map(audit => (
                          <tr style={{ position: 'relative', border: "0", borderBottom: '0px solid #077e1a' }}>

                            {/* <td><RelFormFormulario7>{audit.rtiSubArea}</RelFormFormulario7></td> */}
                            <td>
                              {audit.rtiSubAreaRelato !== '' && audit.rtiSubAreaRelato !== undefined ?
                                <p><RelFormFormulario7>- {audit.rtiSubAreaRelato}</RelFormFormulario7></p>
                                : ''}
                              <p><RelFormFormulario7>- {audit.rtiObservacoes}</RelFormFormulario7></p>
                            </td>
                            {/* <td><RelFormFormulario7>{audit.nota}</RelFormFormulario7></td> */}

                          </tr>

                        ))}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </TabelaPadraoRelatorio>
        <TitlePageRel2>EVIDÊNCIAS VISUAIS E OBSERVAÇÕES</TitlePageRel2>
        <TabelaPadraoRelatorio2>
          <div>
            {auditoria.map(audit => (
              <div className='TableImgAudit'>
                <div className='TableImgColImg'>
                  {audit.rtiCaminhoWeb ? (
                    <div
                      style={{
                        background: `url(${audit.rtiCaminhoWeb}) no-repeat center/cover`,

                      }} className='ImgAudit'
                    ></div>
                  ) : (
                    'IMAGEM NÃO ENCONTRADA'
                  )}
                </div>
                <div className='TableImgColRelato'>
                  <p><b><RelFormFormulario7>AREA:</RelFormFormulario7></b></p>
                  <p><RelFormFormulario7>{audit.rtiSubArea}</RelFormFormulario7></p>
                  <p><b><RelFormFormulario7>RELATO AUDITOR:</RelFormFormulario7></b></p>
                  <p><RelFormFormulario7>{audit.rtiObservacoes}</RelFormFormulario7></p>
                  <p><b><RelFormFormulario7>TEXTO EVIDÊNCIA:</RelFormFormulario7></b></p>
                  <p><RelFormFormulario7>{audit.rtiNotaDescricao}</RelFormFormulario7></p>
                </div>
                <div className='TableImgColNota'>
                  <p><RelFormFormulario7>{audit.rtiNotaTexto}</RelFormFormulario7></p>
                  <p><RelFormFormulario7>{audit.rtiNotaValor}</RelFormFormulario7></p>
                </div>
              </div>
            ))}
          </div>
        </TabelaPadraoRelatorio2>
        <p style={{ position: 'relative', pageBreakAfter: 'always' }}></p>
        <CxAssign>
          <Assign>
            {audAssinatura ? (
              <img alt="" src={audAssinatura} width={150} height={150} />
            ) : (
              ''
            )}
            ____________________ <br />
            Cozinha e Saúde
          </Assign>
          <Assign2>
            {audAssinaturaCliente ? (
              <img alt="" src={audAssinaturaCliente} width={150} height={150} />
            ) : (
              ''
            )}
            ____________________
            <br /> Cliente
          </Assign2>
        </CxAssign>
      </ContainerPageRel>
    </div>
  )
}

export default RelatorioAudit
